import { useState } from 'react';
import { useLang } from '../LangContext';

const sectionIds = ['home', 'about', 'programs', 'gallery', 'reviews', 'contact'];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { lang, toggle, t } = useLang();

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo" onClick={() => scrollTo('home')}>
        <img src="/gallery/logo.png" alt="Kids Play Hall Logo" className="logo-icon" style={{ height: '44px', width: '44px', objectFit: 'cover', borderRadius: '50%', border: '2.5px solid transparent', background: 'linear-gradient(white,white) padding-box, linear-gradient(135deg,#ff6b35,#ff4d8d,#7c3aed) border-box', padding: '2px' }} />
        <span className="logo-text">Kids Play Hall</span>
      </div>

      <div className="navbar-right">
        {/* Language Toggle */}
        <button className="lang-toggle" onClick={toggle} aria-label="Toggle language">
          <span className={lang === 'en' ? 'lang-active' : ''}>EN</span>
          <span className="lang-divider">|</span>
          <span className={lang === 'hi' ? 'lang-active' : ''}>हि</span>
        </button>

        <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>

      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
        {sectionIds.map((id, i) => (
          <li key={id}>
            <button
              onClick={() => scrollTo(id)}
              className={id === 'contact' ? 'nav-enroll' : ''}
            >
              {id === 'contact' ? t.navEnroll : t.nav[i]}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
